<template>
  <f7-link
    :href="href"
    :popup-close="closeProfile ? '#popup-profile' : false"
    class="user-info-item"
    @click="$emit('click')"
  >
    <div class="user-info-item-icon">
      {{ emoji }}
    </div>

    <div>
      <div class="user-info-item-title">{{ title }}</div>
      <div class="user-info-item-link">{{ linkText }}</div>
    </div>
  </f7-link>
</template>

<script>
export default {
  name: 'UserInfoItem',

  props: {
    emoji: {
      type: String,
      default: '',
    },

    href: {
      type: String,
      default: '#',
    },

    title: {
      type: [String, Number],
      default: '',
    },

    linkText: {
      type: [String, Number],
      default: '',
    },

    closeProfile: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="less">
.user-info-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: auto !important;
  line-height: 1 !important;

  &:hover {
    .user-info-item-link {
      color: #32acf5;
    }
  }

  &:not(:last-of-type) {
    margin-right: 15px;
  }
}

.user-info-item-icon {
  margin-right: 10px;
  font-size: 30px;
  color: #252525;
}

.user-info-item-title {
  font-size: 16px;
  color: #252525;
}

.user-info-item-link {
  height: auto !important;
  line-height: 1 !important;
  font-size: 10px;
  color: #252525;
}
</style>
